import { useMemo } from "react";
import { encode } from "uqr";

/** A QR code drawn as one SVG path. Black on white so authenticator apps read it in dark mode too. */
/** `scale` is whole pixels per module, so the edges stay sharp enough for a phone camera. */
export function QrCode({ value, scale = 4, label }: { value: string; scale?: number; label: string }) {
  const { path, n } = useMemo(() => {
    const qr = encode(value, { ecc: "M", border: 4 });
    let d = "";
    qr.data.forEach((row, y) =>
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { path: d, n: qr.size };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      width={n * scale}
      height={n * scale}
      viewBox={`0 0 ${n} ${n}`}
      shapeRendering="crispEdges"
      style={{ display: "block", background: "#fff", borderRadius: 8, maxWidth: "100%", height: "auto" }}
    >
      <path d={path} fill="#000" />
    </svg>
  );
}
